import { render } from "./UniqueKeyMessagePage.vue?vue&type=template&id=48815465&scoped=true"
import script from "./UniqueKeyMessagePage.vue?vue&type=script&lang=js"
export * from "./UniqueKeyMessagePage.vue?vue&type=script&lang=js"

import "./UniqueKeyMessagePage.vue?vue&type=style&index=0&id=48815465&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48815465"]])

export default __exports__